export const getSecciones = (pais) => {
    if (pais) {
        return [
            {
              nombre: 'Pendientes',
              value: 'pendiente'
            },
            {
              nombre: 'No llamar',
              value: 'no-llamar'
            },
            {
              nombre: 'No contesta',
              value: 'no-contesta'
            },
            {
              nombre: 'Interesados',
              value: 'interesado'
            },
            {
              nombre: 'Leads',
              value: 'lead'
            },
            {
              nombre: 'Clientes',
              value: 'cliente'
            },
            {
              nombre: 'Ecommerce',
              value: 'cliente-ecommerce'
            },
            {
              nombre: 'Perdidos',
              value: 'cliente-perdido'
            },
            {
              nombre: 'Grandes Cuentas',
              value: 'cliente-grande'
            },
            {
              nombre: 'Happyrobot',
              value: 'happyrobot'
            },
            {
              nombre: 'Tickets',
              value: 'ticket'
            }
        ];
    } else {
        return [
            {
              nombre: 'Pendientes',
              value: 'pendiente'
            },
            {
              nombre: 'No llamar',
              value: 'no-llamar'
            },
            {
              nombre: 'No contesta',
              value: 'no-contesta'
            },
            {
              nombre: 'Interesados',
              value: 'interesado'
            },
            {
              nombre: 'Leads',
              value: 'lead'
            },
            {
              nombre: 'Clientes',
              value: 'cliente'
            },
            {
              nombre: 'Ecommerce',
              value: 'cliente-ecommerce'
            },
            {
              nombre: 'Perdidos',
              value: 'cliente-perdido'
            },
            {
              nombre: 'Grandes Cuentas',
              value: 'cliente-grande'
            },
            {
              nombre: 'Happyrobot',
              value: 'happyrobot'
            },
            {
              nombre: 'Tickets',
              value: 'ticket'
            }
        ]
    }
}